import React from "react";

import {
  TrackingPipelineEvents,
  AnalyticsEvents,
} from "~/sdks/LocalContent/types";

import { useTracking } from "@local-logic/core/tracking";
import { useLocalContent } from "~/sdks/LocalContent/context";

import { CaretRightIcon } from "@phosphor-icons/react";

import type { Marker, MarkerPoint } from "@local-logic/maps";

import * as styles from "./styles";

export function ClusterPopupContent() {
  const tracking = useTracking();
  const {
    activeMarker,
    activeScore,
    selectedPoiSubcategory,
    handleMarkerClick,
  } = useLocalContent();

  const handleMarkerSelect = (marker: Marker) => () => {
    handleMarkerClick({
      id: marker.id,
      latitude: marker.latitude,
      longitude: marker.longitude,
      markers: [marker],
    } as MarkerPoint);

    if (!activeScore || !selectedPoiSubcategory) {
      return;
    }

    const eventAttributes: Record<string, boolean | string | number> = {
      score: activeScore,
      category: selectedPoiSubcategory,
    };

    Object.entries(marker).forEach(([key, value]) => {
      if (
        typeof value === "boolean" ||
        typeof value === "string" ||
        typeof value === "number"
      ) {
        eventAttributes[key] = value;
      }
    });

    tracking.postEvent({
      eventType: TrackingPipelineEvents.MAP_POI_SELECTED_FROM_CLUSTER,
      eventAttributes: Object.entries(eventAttributes).map(([key, value]) => ({
        label: key,
        data: value,
      })),
    });

    tracking.trackAnalyticsEvent({
      eventName: AnalyticsEvents.MAP_POI_SELECTED_FROM_CLUSTER,
      eventAttributes,
    });
  };

  if (!activeMarker || activeMarker.markers.length < 2) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="cluster-popup-content">
      <ul className={styles.list}>
        {activeMarker.markers.map((marker) => (
          <li
            key={`marker-popup-list-${marker.id}`}
            className={styles.item}
            data-testid="marker-popup-list-item"
          >
            <button
              className={styles.button}
              onClick={handleMarkerSelect(marker)}
              data-testid={`marker-popup-item-button-${marker.id}`}
            >
              <span className={styles.itemText}>{marker.name}</span>{" "}
              <CaretRightIcon weight="bold" className={styles.icon} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
